<template>
  <v-layout>
    <v-dialog v-model="dialog" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          {{text}}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
export default {
  name: 'Loading',
  props: {
    dialog: {
      type: Boolean
    },
    text: {
      type: String,
      default: 'Please stand by'
    }
  }
};
</script>



// WEBPACK FOOTER //
// Loading.vue?414e480e